import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ children, className = '', ...props }) => {
  return (
    <button
      className={`btn btn-primary btn-sm ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button; 